<template>
	<ul
		:class="['list', { 'list--vertical': verticalUl }, ulClass]"
		:style="gridStyles"
	>
		<li v-for="(item, idx) in checkboxList" :key="idx" class="list__item">
			<label :class="['list__item__label check-box', labelClass]">
				<input
					:value="item[keyName]"
					:checked="isChecked(item[keyName])"
					:disabled="isDisabled(item[keyName]) || disabled"
					type="checkbox"
					:class="['check-box__input', inputClass]"
					@change="onChange(item[keyName])"
					@keydown.enter="$emit('enter')"
				/>
				<span
					:class="[
						'check-box__text',
						{
							'check-box__text--checked': isChecked(
								item[keyName]
							),
							'check-box__text--disabled': isDisabled(
								item[keyName]
							),
						},
					]"
					>{{ item[valueName] }}</span
				>
			</label>
		</li>
	</ul>
</template>
<script>
	export default {
		name: 'CheckboxList',
		props: {
			checkboxList: {
				type: Array,
				default: () => [],
			},
			value: {
				type: Array,
				default: () => [],
			},
			inputClass: {
				type: String,
				default: '',
			},
			ulClass: {
				type: String,
				default: '',
			},
			labelClass: {
				type: String,
				default: '',
			},
			keyName: {
				type: String,
				default: 'id',
			},
			valueName: {
				type: String,
				default: 'value',
			},
			disabledIds: {
				type: Array,
				default: () => [],
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			verticalUl: {
				type: Boolean,
				default: false,
			},
			girdColumn: {
				type: Number,
				default: 0,
			},
		},
		computed: {
			isChecked() {
				return id => {
					return this.value.some(value => value === id);
				};
			},
			isDisabled() {
				return id =>
					this.disabledIds.some(disabledId => disabledId === id);
			},
			gridStyles() {
				if (this.girdColumn > 0) {
					return {
						display: 'grid',
						gridTemplateColumns: `repeat( ${this.girdColumn}, 1fr)`,
					};
				}
				return '';
			},
		},
		methods: {
			onChange(id) {
				this.$emit('change', id);
				const targetIdx = this.value.findIndex(value => value === id);
				if (targetIdx > -1) {
					this.value.splice(targetIdx, 1);
				} else {
					this.value.push(id);
				}
				this.$emit('input', this.value);
			},
		},
	};
</script>
<style lang="scss" scoped>
	UL.list {
		padding: 0;
		display: inline-flex;
		flex-wrap: wrap;

		&.custom-list {
			flex-direction: column !important;
		}

		.list__item {
			margin-right: 30px;

			&:last-child {
				margin-right: 0;
			}
		}

		.check-box {
			cursor: pointer;
			display: flex;
			margin-left: -4px;
			padding: 7px 4px;
			border-radius: 4px;
			font-size: 0.875rem;

			&:hover {
				background: #f4f7fa;
			}

			&:active {
				background: #dfe6ee;
			}
		}

		.check-box__input {
			cursor: pointer;
			display: block;

			&:focus {
				outline: 1px solid #0099fa;
			}
		}

		.check-box__text {
			cursor: pointer;
			display: block;
			margin: 0 0 0 8px;
			color: #222;
		}

		.check-box__text--checked {
			font-weight: 700;
		}

		.check-box__text--disabled {
			color: #7a839b;
		}
	}

	.list.list--vertical {
		display: block;

		.list__item {
			margin: 0;
		}
	}
</style>
